import axios from "../general/HttpClient";

export const createOrSaveIntegration = (integration) => {
    let url = `/api/Integrations${integration.integrationId ? "/" + integration.integrationId : ""}`;

    if (integration.integrationId) {
        return axios.put(`/api/Integrations/${integration.integrationId}`, integration);
    } else {
        return axios.post(`/api/Integrations`, integration);
    }
};

export const downloadFile = (url, data) => {
    return axios.post(url, data).then((res) => {
        let text = res.data;
        // Create a new Blob object using the response data of the onload object
        var blob = new Blob([text], { type: res.headers.get("Content-Type") });
        //Create a link element, hide it, direct it towards the blob, and then 'click' it programatically
        let a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        //Create a DOMString representing the blob and point the link element towards it
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = res.headers.get("Content-Disposition").split(";")[1].replace('filename="', "").replace('"', "");
        //programatically click the link to trigger the download
        a.click();
        //release the reference to the file by revoking the Object URL
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    });
};
